import script from "./CreateGroupModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateGroupModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreateGroupModal.vue?vue&type=style&index=0&id=6c7fbba3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c7fbba3"]])

export default __exports__